// talk2pay-connection.messages.ts

import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "@/messages/action-buttons.messages";

import { ActivationMessages, activationMessages } from "./activationMessages";
import { DocumentationMessages, documentationMessages } from "./documentationMessages";
import { FeaturesMessages, featuresMessages } from "./featuresMessages";
import { RatesMessages, ratesMessages } from "./ratesMessages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../../layout/sidebar";

export type Talk2PayConnectionMessages = SidebarMessages &
  FeaturesMessages &
  RatesMessages &
  ActivationMessages &
  DocumentationMessages &
  ActionButtonMessages & {
    pageTitle: string;
    breadCrumbTitle: string;

    nextButton: string;
    completeButton: string;

    featuresStepTitle: string;
    ratesStepTitle: string;
    activationStepTitle: string;
    documentationStepTitle: string;
    processingData: string;
  };

export const TALK2PAY_CONNECTION_MESSAGES: Talk2PayConnectionMessages = {
  ...SIDEBAR_MESSAGES,
  pageTitle: "Talk2Pay",
  breadCrumbTitle: "Plataformas",

  nextButton: "Próximo",
  completeButton: "Concluir",

  featuresStepTitle: "Características",
  ratesStepTitle: "Taxas",
  activationStepTitle: "Ativação",
  documentationStepTitle: "Documentação",

  processingData: "Estamos processando seus dados...",

  ...ACTION_BUTTON_MESSAGES,
  ...documentationMessages,
  ...featuresMessages,
  ...ratesMessages,
  ...activationMessages,
};
